import React from "react";
import { UseFormReturn } from "react-hook-form";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { PaymentMethodsValues } from "@/schemas/sellerProfileSchema";
import { PaymentMethodForm } from "../paymentMethodForm/PaymentMethodForm";

interface PaymentMethodDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  form: UseFormReturn<PaymentMethodsValues>;
  onSubmit: (data: PaymentMethodsValues) => void;
  title?: string;
  description?: string;
  isUpdating: boolean;
}

export const PaymentMethodDialog = ({
  open,
  onOpenChange,
  form,
  onSubmit,
  title = "Update Payment Method",
  description = "Update your payment information for receiving funds.",
  isUpdating,
}: PaymentMethodDialogProps) => {
  const handleSubmit =async (data: PaymentMethodsValues) => {
    await onSubmit(data);
    onOpenChange(false); 
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="md:max-w-5xl max-h-[90vh] md:py-10 md:px-6 overflow-y-auto">
        <DialogHeader className="md:pb-5">
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <PaymentMethodForm
          form={form}
          onSubmit={handleSubmit}
          submitButtonText="Update Payment Method"
          showOtherPaymentMethods={false}
          isUpdating={isUpdating}
        />
      </DialogContent>
    </Dialog>
  );
}; 